<template>
  <ImageElement
    v-if="renderWithoutFigure"
    :id="id"
    ref="element"
    :src="src"
    :class="imageClass"
    :style="imageStyle"
    :alt="alt || ''"
    :height="height"
    :width="width"
    :lazy="lazy"
    :sizes="sizes"
    :do-not-convert="doNotConvert || isSvg"
    :preload="preload"
  />
  <PictureElement
    v-else
    ref="element"
    :src="src"
    :src-sm="srcSm"
    :src-md="srcMd"
    :src-lg="srcLg"
    :src-xl="srcXl"
    :image-style="imageStyle"
    :image-class="imageStyle"
    :alt="alt || ''"
    :height="height"
    :width="width"
    :lazy="lazy"
    :sizes="sizes"
    :do-not-convert="doNotConvert || isSvg"
    :preload="preload"
  >
    <slot />
  </PictureElement>
</template>

<script>
/**
 * When we habe 1 source for all viewports, we can use img with option srcset for high resolutions.
 * When we have different images for a breakpoint, we should use the "picture" element.
 */
import { PictureElement, ImageElement } from '@i22-td-smarthome/component-library';

export default {
  name: 'CdnImage',
  components: {
    PictureElement,
    ImageElement,
  },
  props: {
    sizes: {
      type: String,
      default: '', // "sm:100vw md:50vw lg:400px" https://v0.image.nuxtjs.org/components/nuxt-img#sizes
    },
    src: { type: String, required: true },
    srcSm: { type: String, default: null },
    srcMd: { type: String, default: null },
    srcLg: { type: String, default: null },
    srcXl: { type: String, default: null },
    imageClass: { type: String, default: '' },
    imageStyle: { type: String, default: '' },
    alt: { type: String, default: '' },
    id: { type: String, default: null },
    height: { type: Number, default: null },
    width: { type: Number, default: null },
    renderWithoutFigure: { type: Boolean },
    doNotConvert: { type: Boolean },
    lazy: { type: Boolean },
    preload: { type: Boolean },
  },
  computed: {
    isSvg() {
      // We do not want to convert a svg.
      return this.src.endsWith('.svg');
    },
  },
};
</script>
